
import { Base } from '../base-component';

import './search-results.component.scss';

export class SearchResults extends Base {

	constructor(element: Element){

		super(element);
				
	}

	init(){}

	bindEvents() {}
	
}



// WEBPACK FOOTER //
// ./components/search-results/search-results.component.ts